import { render, staticRenderFns } from "./signalItem.vue?vue&type=template&id=af990bfa&scoped=true&"
import script from "./signalItem.vue?vue&type=script&lang=js&"
export * from "./signalItem.vue?vue&type=script&lang=js&"
import style0 from "./signalItem.vue?vue&type=style&index=0&id=af990bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af990bfa",
  null
  
)

export default component.exports